import { useEffect, useState } from "react";
import { apiJson } from "../../utils/api";
import useSeo from "../../hooks/useSeo";

export default function MarriagePolicy() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [disclaimer, setDisclaimer] = useState("");

  useSeo({
    title: "领证政策 | 全国通办与材料说明",
    metaDescription: "整理新修订《婚姻登记条例》后的全国通办、材料与亲自到场要求，并标注官方来源。",
    path: "/marriage/policy",
  });

  const load = (query = "") => {
    apiJson(`/api/marriage/policies${query ? `?q=${encodeURIComponent(query)}` : ""}`)
      .then(({ data }) => {
        setItems(data.items || []);
        setDisclaimer(data.disclaimer || "");
      })
      .catch(() => setItems([]));
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-extrabold">🏛️ 我要领证</h1>
      <p className="text-sm text-gray-500">优先展示全国性官方政策整理。各地周末号源、窗口地址请再核验当地公告。</p>
      <form
        className="flex gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          load(q);
        }}
      >
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="例如：户口本、外地户口、周末"
          className="flex-1 border rounded-xl px-4 py-2"
        />
        <button className="px-5 py-2 rounded-xl bg-rose-500 text-white">查询</button>
      </form>
      {disclaimer ? <p className="text-xs text-gray-500">{disclaimer}</p> : null}
      <div className="space-y-4">
        {items.map((item) => (
          <article key={item.id} className="bg-white rounded-2xl p-5 border border-rose-100 shadow-sm">
            <h2 className="font-bold text-lg">{item.title}</h2>
            <p className="text-sm text-gray-600 mt-3 whitespace-pre-wrap">{item.content}</p>
            <div className="mt-4 text-xs text-gray-500 space-y-1">
              <p>政策依据：{item.source_name}</p>
              <p>更新/核验时间：{item.last_verified_at || item.published_at || "—"}</p>
              {item.official_url ? (
                <p>
                  官方来源：
                  <a className="text-rose-600 ml-1" href={item.official_url} target="_blank" rel="noreferrer">
                    {item.official_url}
                  </a>
                </p>
              ) : null}
              <p>说明：{item.disclaimer}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
